import { render } from "./PaymentPreview.vue?vue&type=template&id=1f15f1cc&scoped=true"
import script from "./PaymentPreview.vue?vue&type=script&lang=js"
export * from "./PaymentPreview.vue?vue&type=script&lang=js"

import "./PaymentPreview.vue?vue&type=style&index=0&id=1f15f1cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f15f1cc"]])

export default __exports__